var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group"},[_c('el-form-item',{attrs:{"label":"Placeholder (Range Values)"}},[_c('el-input',{model:{value:(_vm.field.placeholder1),callback:function ($$v) {_vm.$set(_vm.field, "placeholder1", $$v)},expression:"field.placeholder1"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }